export enum MonitoringMode {
  LIVE = 'LIVE',
  HISTORICAL = 'HISTORICAL',
}
